export default "__VITE_ASSET__Btr91VqY__"